import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { QRCodeSVG } from 'qrcode.react';
import { Check, Copy } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function inviteUrl(token: string): string {
  return `${window.location.origin}/join/${token}`;
}

export function InviteQr({ token, size = 200 }: { token: string; size?: number }) {
  const { t } = useTranslation();
  const url = inviteUrl(token);
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
    }
  }

  return (
    <div className="flex flex-col items-center gap-3">
      {}
      <div className="rounded-lg bg-white p-3">
        <QRCodeSVG
          value={url}
          size={size}
          level="M"
          marginSize={0}
          title={t('invite.qrTitle')}
        />
      </div>
      <div className="flex w-full items-center gap-2">
        <code className="min-w-0 flex-1 truncate rounded-md bg-muted px-2 py-1.5 text-xs">
          {url}
        </code>
        <Button
          variant="outline"
          size="icon-sm"
          onClick={copy}
          aria-label={t('invite.copyLink')}
        >
          {copied ? <Check /> : <Copy />}
        </Button>
      </div>
    </div>
  );
}
